import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { isArrayEqual } from 'utils';
import './SelectAllButton.less';

const SelectAllButton = ({ selected, setSelected, allIds }) => {
  const selectedAll = isArrayEqual(selected, allIds);

  if (selectedAll) {
    return (
      <Button
        key="cancel-selected"
        type="default"
        className="btn-fade-in"
        onClick={() => setSelected([])}
      >
        Cancel selected
      </Button>
    );
  }

  return (
    <Button
      key="select-all"
      type="primary"
      className="btn-fade-in"
      onClick={() => setSelected(allIds)}
    >
      Select all
    </Button>
  );
};

SelectAllButton.propTypes = {
  selected: PropTypes.array.isRequired,
  allIds: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired,
};

export default SelectAllButton;
